import oktaConfig from "../../configs/okta";
import * as Auth from "../authService";
import { clearSessionStorage } from "./storageService";

export const logError = (error: any) => {
  if (error != undefined) {
    // Token is expired, relogin is required
    if (typeof error === "string" && error.includes("403")) {
      Auth.customLogout().then(() => {
        clearSessionStorage();
        window.location.href = `${oktaConfig.api.redirectUri}`;
      });
    } else {
      if (error instanceof Error) {
        console.error(error);
      }
    }
  }
};

export const logWarn = (error: any) => {
  console.warn("WARN", error);
};

export const defaultLog = (error: any) => {
  console.log("LOG:", error);
};
